import { SupportedLocale } from '@/utils/intl';
import { useCurrentLocale } from '@rhg/hooks/use-current-language';
import dynamic from 'next/dynamic';
import { PropsWithChildren } from 'react';

const EnLocalizationProvider = dynamic(() =>
    import('./lang/en').then((mod) => mod.EnLocalizationProvider)
);

const EsLocalizationProvider = dynamic(() =>
    import('./lang/es').then((mod) => mod.EsLocalizationProvider)
);

const FrLocalizationProvider = dynamic(() =>
    import('./lang/fr').then((mod) => mod.FrLocalizationProvider)
);

const EnGBLocalizationProvider = dynamic(() =>
    import('./lang/en-GB').then((mod) => mod.EnGBLocalizationProvider)
);

const EnCALocalizationProvider = dynamic(() =>
    import('./lang/en-CA').then((mod) => mod.EnCALocalizationProvider)
);

export function LocalizationProvider({ ...props }: PropsWithChildren) {
    const locale = useCurrentLocale();
    switch (locale) {
        case SupportedLocale.FR:
            return <FrLocalizationProvider {...props} />;
        case SupportedLocale.ES:
            return <EsLocalizationProvider {...props} />;
        case SupportedLocale.ENgb:
            return <EnGBLocalizationProvider {...props} />;
        case SupportedLocale.ENca:
            return <EnCALocalizationProvider {...props} />;
        default:
            return <EnLocalizationProvider {...props} />;
    }
}
